import { Icon } from "@iconify/react";
import SkeletonTable from "../../common/SkeletonTable";
import Pagination from "../Pagination";
import Select from "react-select";
import { changeStatus } from "../../../callApi/httpservice";
import { useStores } from "../../../srores";
interface ComponentProps {
  items: any;
  offset: number;
  pageCount: number;
  handlePageClick: any;
  isFetching: boolean;
  callApiGetUser: any;
  take: number;
  skip: number;
}
export default function ManagerUserTable(props: ComponentProps) {
  /*
   * Props of Component
   */
  const {
    items,
    offset,
    pageCount,
    handlePageClick,
    isFetching,
    callApiGetUser,
    take,
    skip,
  } = props;
  const { adminStore } = useStores();

  const theme = (theme: any) => ({
    ...theme,
    colors: {
      ...theme.colors,
      primary25: "#D4D4D4",
      primary: "#eed484",
    },
  });

  const styles = {
    control: (base: any, state: any) => ({
      ...base,
      background: "rgb(245 245 245 / var(--tw-bg-opacity))",
      border: 0,
      boxShadow: "none",
      borderRadius: 6,
      width: adminStore.windowWidth > 768 ? "unset" : "100px",
    }),
    option: (styles: any, state: any) => {
      return {
        ...styles,
        ":active": {
          backgroundColor: "#D4D4D4",
        },
      };
    },
  };
  const collums = ["User", "Role", "Status", "Action"];
  const optionsStatus = [
    { value: "DEACTIVATED", label: "Deactivated" },
    { value: "ACTIVATED", label: "Activated" },
  ];
  const onStatusChange = async (e: any, email: string) => {
    const body = {
      email,
      deactivated: e.value === "DEACTIVATED" ? true : false,
    };
    const result = await changeStatus(body);
    if (result.status === 200) {
      callApiGetUser(take, skip);
    }
  };
  return (
    <>
      <div>
        <div className="flex items-center">
          <div className=" text-[#242424] font-bold xsm:text-[16px] xs:text-[18px]">
            {"Manage member"}
          </div>
        </div>
        <hr className="mt-2" />
        <div className="flex flex-col">
          <div className="overflow-x-scroll">
            <div className=" pt-2 w-full inline-block align-middle">
              <div className=" xl:overflow-x-hidden xsm:overflow-x-scroll border rounded-lg">
                <table className="min-w-full xl:overflow-x-hidden xsm:overflow-x-scroll">
                  <thead className="bg-[#222221]">
                    <tr className="text-[#EED484] text-center font-bold text-xs">
                      {collums.map((collum, index: any) => (
                        <th scope="col" className="px-6 py-3" key={index}>
                          {collum}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody className="">
                    {items &&
                      items.map((item: any, index: number) => (
                        <tr
                          className={
                            (index + 1) % 2
                              ? " text-[#222221] text-center bg-white"
                              : " text-[#222221] text-center bg-[#E0E0E0]"
                          }
                          key={index}
                        >
                          <td className="px-6 py-4">{item.email}</td>
                          <td className="px-6 py-4">{item.role}</td>
                          <td className="px-6 py-4 flex items-center justify-center">
                            {item.deactivated ? (
                              <div className="flex items-center gap-2">
                                <Icon
                                  icon={"pajamas:status-active"}
                                  width={10}
                                  color={"#A6192E"}
                                />
                                Deactivated
                              </div>
                            ) : (
                              <div className="flex items-center gap-2">
                                <Icon
                                  icon={"pajamas:status-active"}
                                  width={10}
                                  color={"#00685E"}
                                />
                                Activated
                              </div>
                            )}
                          </td>
                          <td className="px-2 py-2 lg:w-[12%] xl:w-[11%]">
                            <Select
                              value={
                                item.deactivated
                                  ? optionsStatus[0]
                                  : optionsStatus[1]
                              }
                              className=" rounded-md"
                              placeholder="Change status"
                              options={optionsStatus}
                              theme={theme}
                              styles={styles}
                              isSearchable={false}
                              components={{
                                IndicatorSeparator: () => null,
                              }}
                              onChange={(e: any) => {
                                onStatusChange(e, item.email);
                              }}
                            />
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        {isFetching && !items && (
          <div className="mt-5">
            <SkeletonTable row={5} />
          </div>
        )}
        {!isFetching && !items && (
          <div className="text-center text-black mt-10">Data is empty!</div>
        )}
        <div className=" flex justify-end xsm:mt-0 xs:mt-2 items-center">
          {pageCount > 0 && (
            <div className="flex items-center justify-center">
              <Pagination
                pageCount={pageCount}
                handlePageClick={handlePageClick}
                offset={offset}
              />
            </div>
          )}
        </div>
      </div>
    </>
  );
}
